import { SessionMessage } from './session/SessionMessage';

// /error route (desktop): "Session closed" and the other end-of-session / access messages, in the
// IBISengage chrome. Title and text come from the navigation state ({ title, error }).
const Error = () => <SessionMessage />;

export default Error;
